import { useSelector } from "react-redux";
import _ from "lodash";
import dayjs from "dayjs";
import { TICKET_STATUS } from "../../../../store/constants";
import { generateHoursArray } from "../../../../store/helpers";

const useTickets = ({ branchId }) => {
  const { tickets } = useSelector((state) => state.realtimeReducer);
  const { workDay } = useSelector((state) => state.defaultReducer);
  const ticketsClone = _.cloneDeep(tickets).filter(
    (a) => a.branchId === branchId
  );
  const totalTickets = ticketsClone.length;
  const numCompletedTickets = ticketsClone.filter(
    (a) => Number(a.status) === TICKET_STATUS.COMPLETED
  ).length;
  const numActiveTickets = ticketsClone.filter(
    (a) => Number(a.status) === TICKET_STATUS.ACTIVE
  ).length;

  const numNoShowTickets = ticketsClone.filter(
    (a) => Number(a.status) === TICKET_STATUS.NO_SHOW
  ).length;

  const startTimeStamp = dayjs()
    .set("hour", workDay[0].split(" ")[0])
    .set("minute", 0)
    .unix();
  const endTimeStamp = dayjs().unix();
  const hoursBetween = generateHoursArray(startTimeStamp, endTimeStamp);
  const chart = hoursBetween.map((hour) => {
    const hourTickets = ticketsClone.filter(
      (a) => dayjs.unix(a.created).format("h A") === hour
    );
    return {
      hour,
      total: hourTickets.length,
    };
  });

  return {
    totalTickets,
    numCompletedTickets,
    numActiveTickets,
    numNoShowTickets,
    chart,
  };
};

export default useTickets;
